/**
 * Campaigns (spec 40 §4.1, S40-1): statuses and field limits shared by API
 * (validation, OpenAPI) and web (form hints). The database repeats them as
 * CHECKs (migration 0019).
 */
export const CAMPAIGN_STATUSES = ['draft', 'active', 'completed', 'archived'];
export const CAMPAIGN_LIMITS = {
    nameMaxLength: 120,
    goalMaxLength: 2000,
    ctaMaxLength: 300,
    landingUrlMaxLength: 2048,
    maxTargetMarkets: 50,
    maxLanguages: 20,
    maxPillars: 20,
    maxPlannedCount: 10000,
};
/**
 * Campaign roles (spec 40 section 4.1a, E300 S300-2, REQ-40-029): `opening` and `closing`
 * at most once per campaign, `moment` any number of times. The database repeats them
 * as a CHECK (migration 0136).
 */
export const CAMPAIGN_ROLES = ['opening', 'moment', 'closing'];
/** The roles a campaign holds only once. */
export const SINGLE_CAMPAIGN_ROLES = ['opening', 'closing'];
/** Upper bound per role in `campaigns.role_targets` (spec 40 section 4.1a). */
export const CAMPAIGN_ROLE_TARGET_MAX = { opening: 1, moment: 8, closing: 1 };
/** A row of the campaign progress (spec 40 section 4.1a): `unassigned` collects posts without a role. */
export const CAMPAIGN_PROGRESS_ROLES = [...CAMPAIGN_ROLES, 'unassigned'];
/** A calendar day `YYYY-MM-DD` that exists (`2026-02-30` does not). */
export function isCalendarDate(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value))
        return false;
    const date = new Date(`${value}T00:00:00Z`);
    return !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === value;
}
//# sourceMappingURL=campaigns.js.map